<template>
  <img src="../../public/demo-logo.png" alt="Coolfix logo" class="logo" style="height: 45px" />
</template>

<script lang="ts" setup></script>
